import { t } from "@lingui/macro";

import { RecurringRequestPreviewState } from "@/features/RecurringRequests/types";
import { Button } from "@whoosh/design-system/src/components/controls";
import { LoadingSpinner } from "@whoosh/design-system/src/components/display/Loader/LoadingSpinner";
import {
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

export const RecurringRequestPreviewStatus = ({
  state,
  onRetry,
}: {
  state: RecurringRequestPreviewState;
  onRetry: () => void;
}) => {
  if (state.status === "loading")
    return (
      <HStack
        gap={3}
        alignItems="center"
        testID="recurring-request-preview-loading"
      >
        <LoadingSpinner />
        <Text variant="mainBaseMedium">{t`Checking recurring request dates…`}</Text>
      </HStack>
    );
  if (state.status !== "error") return null;
  return (
    <VStack gap={3} testID="recurring-request-preview-error">
      <Text variant="mainBaseMedium" accessibilityRole="alert">
        {state.message}
      </Text>
      <Button
        variant="secondary"
        size="small"
        accessibilityLabel={t`Retry recurring request preview`}
        onPress={onRetry}
      >
        {t`Retry`}
      </Button>
    </VStack>
  );
};
